import React from 'react';
import PropTypes from 'prop-types';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class ToolTip extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            show: this.props.show
        };
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.props.onHide();
        }
    }

    render() {
        return (
            <div className={`tool-tip ${this.props.class}`} ref={this.props.id} onClick={this.props.onHide} onKeyDown={this.setKeyboardAccessibility} tabIndex={0} role="link">
                <div className="tool-tip-content-wrapper">
                    {this.props.childComponentProps !== null || typeof this.props.childComponentProps !== 'undefined'
                        ? <this.props.childComponent {...this.props.childComponentProps}/>
                        : <this.props.childComponent />
                    }
                </div>
            </div>
        );
    }
}

ToolTip.propTypes = {
    childComponent: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    childComponentProps: PropTypes.object,
    class: PropTypes.string
};

ToolTip.contextTypes = {
    router: PropTypes.object
};

export default ToolTip;



/** WEBPACK FOOTER **
 ** ./src/components/objects/tooltip/ToolTip.js
 **/